import { BaseViewStore } from 'core/stores';
import { action, computed, observable } from "mobx";
import moment from 'moment';
class NikoFacilityOrderStatusBarViewStore extends BaseViewStore {
    @observable accessor isStatusBarVisible = true;
    constructor(rootStore, componentProps) {
        super(rootStore);

        this.rootStore = rootStore;
        this.title = componentProps.title;
        this.pageViewStore = componentProps.pageViewStore;

        const userRoles = this.rootStore.userStore.applicationUser.roles;
        this.isStatusBarAllowed = !(userRoles.includes("InitialIntake") || userRoles.includes("InsuranceReview"));
        this.isInventoryStepAllowed = userRoles.includes("Biller") || userRoles.includes("Administrators");
        this.isMasterEditor = userRoles.includes("Master Editor");
    }

    @computed
    get areStepsDisabled() {
        return !this.isMasterEditor && this.pageViewStore.facilityOrder && this.pageViewStore.facilityOrder.sendOrder;
    }

    @action.bound
    async openPage(page) {
        window.open(this.rootStore.routerStore.findRoute(`master.app.main.niko-facility-order.${page}-preview`).pattern.replace(":id", this.pageViewStore.facilityOrder.id));
    }

    @action.bound
    getStatusButtonClassName(button) {
        let initialIntakeStatus = this.pageViewStore.facilityOrder.facilityOrderStatuses.find(x => x.status && x.status.abrv === "initial-intake");
        let insuranceReviewStatus = this.pageViewStore.facilityOrder.facilityOrderStatuses.find(x => x.status && x.status.abrv === "insurance-review");
        let usIntakeStatus = this.pageViewStore.facilityOrder.facilityOrderStatuses.find(x => x.status && x.status.abrv === "us-intake");
        let clinicalReviewStatus = this.pageViewStore.facilityOrder.facilityOrderStatuses.find(x => x.status && x.status.abrv === "clinical-review");
        let inventoryStatus = this.pageViewStore.facilityOrder.facilityOrderStatuses.find(x => x.status && x.status.abrv === "inventory");
        let billingStatus = this.pageViewStore.facilityOrder.facilityOrderStatuses.find(x => x.status && x.status.abrv === "imported");
        let orderSummary = this.pageViewStore.facilityOrder.facilityOrderStatuses.find(x => x.status && x.status.abrv === "order-summary");

        if (button === "initial-intake") {
            if (!initialIntakeStatus) {
                if (insuranceReviewStatus || usIntakeStatus || clinicalReviewStatus) {
                    return "is-skipped";
                }
                return "is-not-started";
            } else if (initialIntakeStatus.completedOn) {
                return "is-completed";
            } else if (insuranceReviewStatus || usIntakeStatus || clinicalReviewStatus) {
                return "is-skipped";
            } else {
                return "is-in-progress";
            }
        } else if (button === "insurance-review") {
            if (!insuranceReviewStatus) {
                if (usIntakeStatus || clinicalReviewStatus) {
                    return "is-skipped";
                }
                return "is-not-started";
            } else if (insuranceReviewStatus.completedOn) {
                return "is-completed";
            } else if (usIntakeStatus || clinicalReviewStatus) {
                return "is-skipped";
            } else {
                return "is-in-progress";
            }
        }
        else if (button === "us-intake") {
            if (usIntakeStatus) {
                if (usIntakeStatus.completedOn) {
                    return "is-completed";
                }
                return "";
            }
            return "is-not-started";
        }
        else if (button === "clinical-review") {
            if (clinicalReviewStatus) {
                if (clinicalReviewStatus.completedOn) {
                    return "is-completed";
                }
                return "";
            }
            return "is-not-started";
        }
        else if (button === "inventory") {
            if (this.pageViewStore.facilityOrder.missingInventoryCount) {
                return "is-skipped";
            }
            if (inventoryStatus) {
                if (inventoryStatus.completedOn) {
                    return "is-completed";
                }
                return "";
            }
            return "is-not-started";
        }
        else if (button === "order-summary") {
            if (orderSummary) {
                if (orderSummary.completedOn) {
                    return "is-completed";
                }
                return "";
            }
            return "is-not-started";
        }
        else if (button === "billing") {
            if (billingStatus) {
                if (billingStatus.completedOn) {
                    return "is-completed";
                }
                return "";
            }
            return "is-not-started";
        }
    }

    formatDate(dateString) {
        return moment(dateString).format("MMMM DD,YYYY, [at] hh:mmA");
    }

    formatTooltip(user, completedOn) {
        return "<div style='text-align:center'>" + user.fullName + "<br />" + this.formatDate(completedOn) + "</div>";
    }

    @action.bound
    getUserAndDateCompleted(button) {
        let initialIntakeStatus = this.pageViewStore.facilityOrder.facilityOrderStatuses.find(x => x.status && x.status.abrv === "initial-intake");
        let insuranceReviewStatus = this.pageViewStore.facilityOrder.facilityOrderStatuses.find(x => x.status && x.status.abrv === "insurance-review");
        let usIntakeStatus = this.pageViewStore.facilityOrder.facilityOrderStatuses.find(x => x.status && x.status.abrv === "us-intake");
        let clinicalReviewStatus = this.pageViewStore.facilityOrder.facilityOrderStatuses.find(x => x.status && x.status.abrv === "clinical-review");
        let inventoryStatus = this.pageViewStore.facilityOrder.facilityOrderStatuses.find(x => x.status && x.status.abrv === "inventory");
        let billingStatus = this.pageViewStore.facilityOrder.facilityOrderStatuses.find(x => x.status && x.status.abrv === "imported");
        let orderSummary = this.pageViewStore.facilityOrder.facilityOrderStatuses.find(x => x.status && x.status.abrv === "order-summary");

        if (button === "initial-intake") {
            if (initialIntakeStatus && initialIntakeStatus.completedByUser) {
                return this.formatTooltip(initialIntakeStatus.completedByUser, initialIntakeStatus.completedOn);
            }
        }
        else if (button === "insurance-review") {
            if (insuranceReviewStatus && insuranceReviewStatus.completedByUser) {
                return this.formatTooltip(insuranceReviewStatus.completedByUser, insuranceReviewStatus.completedOn);
            }
        }
        else if (button === "us-intake") {
            if (usIntakeStatus && usIntakeStatus.completedByUser) {
                return this.formatTooltip(usIntakeStatus.completedByUser, usIntakeStatus.completedOn);
            }
        }
        else if (button === "clinical-review") {
            if (clinicalReviewStatus && clinicalReviewStatus.completedByUser) {
                return this.formatTooltip(clinicalReviewStatus.completedByUser, clinicalReviewStatus.completedOn);
            }
        }
        else if (button === "inventory") {
            if (inventoryStatus && inventoryStatus.completedByUser) {
                return this.formatTooltip(inventoryStatus.completedByUser, inventoryStatus.completedOn);
            }
        }
        else if (button === "order-summary") {
            if (orderSummary && orderSummary.completedByUser) {
                return this.formatTooltip(orderSummary.completedByUser, orderSummary.completedOn);
            }
        }
        else if (button === "billing") {
            if (billingStatus && billingStatus.completedByUser) {
                return this.formatTooltip(billingStatus.completedByUser, billingStatus.completedOn);
            }
        }
    }

    @action.bound
    changeStatusBarVisibility() {
        this.isStatusBarVisible = !this.isStatusBarVisible;
    }
}

export default NikoFacilityOrderStatusBarViewStore;

